<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
          ">
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <transition name="fade">
          <div class="row mb-3" v-if="selectedDocs.length !== 0">
            <div class="col-12">
              <b-button @click="onDeleteDocs()" variant="primary">
                <i class="bx bx-trash"></i> {{ $t("pages.workflow.details.documents.delete") }}
              </b-button>
            </div>
          </div>
        </transition>
        <div v-if="false" class="mt-2">
          <b-skeleton-table :rows="6" :columns="4"></b-skeleton-table>
        </div>
        <table class="table" v-if="documents.length != 0">
          <thead class="thead-light">
            <tr>
              <th><input type="checkbox" v-model="selectAllDocs"></th>
              <th>{{ $t("pages.workflow.details.document") }}</th>
              <th>{{ $t("pages.workflow.details.status") }}</th>
              <th>{{ $t("pages.workflow.details.actor") }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(document, index) in pageOfItems" :key="index" v-bind:class="{
              'selected': selectedDocs.includes(document.id)
            }">
              <td>
                <input type="checkbox" :value="document.id" v-model="selectedDocs" style="cursor: pointer;">
              </td>
              <td>{{ document.name }}</td>
              <td>
                <span v-bind:class="{ 
                  'p-1 badge badge-success': document.doc_state === 'Approved',
                  'p-1 badge badge-warning': document.doc_state === 'Waiting',
                  'p-1 badge badge-danger': document.doc_state === 'Rejected',
                }">
                  {{ getStateName(document.doc_state) }}
                  {{ document.doc_state == 'Waiting' ? document.state_name : '' }}
                </span>
              </td>
              <td>{{ document.user_name }}</td>
              <td class="text-center">
                <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                  <template v-slot:button-content>
                    <i class="mdi mdi-dots-horizontal font-size-18"></i>
                  </template>
                  <b-dropdown-item @click="onDelete(document)">
                    {{ $t("pages.workflow.details.documents.delete") }}
                  </b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="text-center" v-else>
          <div class="row">
            <div class="col-md-3 mx-auto">
              <lottie-animation ref="anim" :animationData="require('@/assets/json/empty-state.json')" :loop="true" />
            </div>
          </div>
          <h4 class="text-center">{{ $t("pages.workflow.details.documents.empty.title") }}</h4>
          <p class="mt-2">
            {{ $t("pages.workflow.details.documents.empty.text") }}
          </p>
        </div>
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="text-center">
              <jw-pagination :pageSize="pageSize" :items="documents" @changePage="onChangePage" :labels="labels"
                class="text-center"></jw-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import { mapActions } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
  page: {
    title: "users",
  },
  components: {
    Layout,
    LottieAnimation
  },

  data() {
    return {
      title: "pages.workflow.details.title",      
      showModal: false,      
      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },
      documents: [],
      selectedDocs: [],
      isLoading: false,
      pageOfItems: [],
      pageSize: 10,
    };
  },
  methods: {
    ...mapActions(["getDocuments", "deleteDocumentFromProcess"]),
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    closeModal() {
     this.showModal = false;
    },
    getStateName(state) {
      switch (state) {
        case 'Waiting':
          return this.$t("pages.workflow.details.waiting");
        case 'Approved':
          return this.$t("pages.workflow.details.approved");
        case 'Rejected':
          return this.$t("pages.workflow.details.rejected");
        default:
          return this.$t("pages.workflow.details.cancelled");
      }
    },
    onDelete(document) {
      this.$toasted.clear();
      this.$swal({
        text: this.$t("pages.workflow.details.documents.swal") + ` ${document.name} ?`,
        confirmButtonColor: "#d33",
        confirmButtonText: this.$t("pages.workflow.details.documents.delete"),
      }).then((result) => {
        if (result.value) {
          let data = {
            document_id: [document.id],
            process_id: this.$route.params.id
          }
          this.deleteDocumentFromProcess(data).then(()=>{
            this.$swal(
              this.$t("pages.workflow.details.documents.actions.confirm"),
              this.$t("pages.workflow.details.documents.actions.deleted"),
              "success"
            );
          });
          this.getDocuments(this.$route.params.id).then((response) => { 
            this.documents = response.data;
            this.isLoading = false;
          })
        }
      });
    },
    onDeleteDocs(){
      this.$toasted.clear();
      this.$swal({
        text: this.$t("pages.workflow.details.documents.swal_many"),
        confirmButtonColor: "#d33",
        confirmButtonText: this.$t("pages.workflow.details.documents.delete"),
      }).then((result) => {
        this.isLoading = true;
        if (result.value) {
          let data = {
            document_id: this.selectedDocs,
            process_id: this.$route.params.id
          }
          this.deleteDocumentFromProcess(data).then(()=>{
            this.$swal(
              this.$t("pages.workflow.details.documents.actions.confirm"),
              this.$t("pages.workflow.details.documents.actions.deleted"),
              "success"
            );
          });
          this.getDocuments(this.$route.params.id).then((response) => { 
            this.documents = response.data;
            this.isLoading = false;
          })
          this.selectedDocs = [];
        }
      });
    }
  },
  computed: {
    selectAllDocs: {
      get: function () {
          return this.documents ? this.selectedDocs.length == this.documents.length : false;
      },
      set: function (value) {
          var selectedDocs = [];

          if (value) {
              this.documents.forEach(function (document) {
                  selectedDocs.push(document.id);
              });
          }

          this.selectedDocs = selectedDocs;
      }
    }
  },
  created() {
    this.isLoading = true;
    this.getDocuments(this.$route.params.id).then((response) => {
      this.documents = response.data;
      this.isLoading = false;
    });
  },
};
</script>